import { Component } from '@angular/core';
import { FrameComponent } from '../frame/frame.component';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends FrameComponent {
  public isLoggedIn = false;
  public userProfile: KeycloakProfile | null = null;
  isUser = false;
  isAdmin = false;
  currentHref: string = 'trasparenza'; // Default

  constructor(
    private readonly keycloak: KeycloakService, private router: Router
  ) {
    super();
  }

  override ngOnInit(): void {
    const url = this.router.url;
    this.currentHref = url.includes('admin') ? 'admin' : 'trasparenza';
  }

  protected override async init() {
    this.isLoggedIn = await this.keycloak.isLoggedIn();

    /* alternative
      this.keycloak.isLoggedIn().then((authenticated) => {
        this.authenticated = authenticated;
        if (authenticated) {
          ...
        }
      });
     */

    if (this.isLoggedIn) {
      this.userProfile = await this.keycloak.loadUserProfile();
      const roles = this.keycloak.getUserRoles();
      this.isUser = roles.includes('USER');
      this.isAdmin = roles.includes('ADMIN');
      this.rightChoices.push({ label: (this.isUser) ? 'User' : 'Admin', route: '/profile' });
    }
  }

  public login() {
    this.keycloak.login();
  }

  public logout() {
    this.keycloak.logout();
  }

  rightChoices: any[] = [
    {
      label: 'Trasparenza',
      route: '/trasparenza'
    }];



}
